import React from "react";
import * as styles from "./styles.mod.scss";
import Image from "components/image";
import { Container } from "react-bootstrap";
import RichText from "components/rich-text";

const FounderSection = ({ data }) => {

  let foundersContent = styles.foundersContent;
  let signatureFooter = styles.signatureFooter;
  if (data?.rightSideImage) {
    foundersContent = `${styles.foundersContent} ${styles.newFoundersContent}`;
    signatureFooter = `${styles.signatureFooter} ${styles.newSignatureFooter}`;
  }

  const bgColor = data?.bgColor && data?.bgColor?.hex;

  const layout = `row${data?.imageRightLayout ? "-reverse" : ""}`;

  return (
    <div className={styles.founderSection}>
      <Container>
        <div style={{
          backgroundColor: bgColor, 
          flexDirection: layout
        }} 
        className={styles.founderSectionBox}>
          <div className={data?.rightSideImage ? `${styles.foundersImage} ${styles.newFoundersImage}` : styles.foundersImage}>
            <Image image={data?.heroImage} alt={data?.heroImage?.alt} />
          </div>

          <div className={foundersContent}>
            <RichText blocks={data?.text} />
            <div className={signatureFooter}>
              {data?.founders &&
                <div className={styles.text}>
                  <p dangerouslySetInnerHTML={{ __html: data?.founders }}></p>
                </div>}
              <div className={styles.signature}>
                <Image image={data?.signature} alt={data?.signature?.alt} />
              </div>
            </div>
          </div>
          {data?.rightSideImage &&
            <div className={styles.rightSideImage}>
              <Image image={data?.rightSideImage} alt={data?.rightSideImage?.alt} />
            </div>}
        </div>
      </Container>
    </div>
  );
};

export default FounderSection;